export default [
  {
    fullName: 'Обухова Елизавета',
    jobTitle: 'Начальник Центра роботизации процессов',
    description: 'Газпромбанк.Тех',
    photo: require('@/assets/speakers/Поваляева.jpg')
  },
  {
    fullName: 'Ильина Анастасия',
    jobTitle: 'Директор проекта. Центр роботизации процессов.',
    description: 'Газпромбанк.Тех',
    photo: require('@/assets/speakers/Ильина.jpg')
  },
  {
    fullName: 'Голубинцев Алексей',
    jobTitle: 'Заместитель начальника Департамента банковских процессов',
    description: 'Газпромбанк.Тех',
    photo: require('@/assets/speakers/Голубинцев.jpg')
  },
  {
    fullName: 'Гоношилов Максим',
    jobTitle: 'Зам. Начальника Центра Роботизации процессов',
    description: 'Газпромбанк.Тех',
    photo: require('@/assets/speakers/Гоношилов.png')
  },
  {
    fullName: 'Белов Михаил',
    jobTitle: 'Руководитель команды разработки RPA',
    description: 'X5 Tech',
    photo: require('@/assets/speakers/Белов.jpg')
  },
  {
    fullName: 'Иванова Екатерина',
    jobTitle: 'Аналитик роботизации',
    description: 'X5 Tech',
    photo: require('@/assets/speakers/Иванова.jpg')
  },
  {
    fullName: 'Карамышев Сергей',
    jobTitle: 'Менеджер направления аналитики и роботизации',
    description: 'X5 Технологии',
    photo: require('@/assets/speakers/Карамышев.jpg')
  },
  {
    fullName: 'Бочкин Александр',
    jobTitle: 'Генеральный директор и основатель Инфомаксимум',
    description: 'Инфомаксимум',
    photo: require('@/assets/speakers/Бочкин.jpg')
  },
  {
    fullName: 'Игнатов Антон',
    jobTitle: 'Модератор',
    description: 'PIX Robotics',
    photo: require('@/assets/speakers/Игнатов.jpg')
  },
  {
    fullName: 'Елисеев Максим ',
    jobTitle: 'Руководитель отраслевой роботизации',
    description: 'Гринатом',
    photo: require('@/assets/speakers/Елисеев.jpg')
  },
  {
    fullName: 'Комраков Николай',
    jobTitle: 'Ведущий консультант по цифровым продуктам',
    description: 'АтомРИТА',
    photo: require('@/assets/speakers/Комраков.jpg')
  },
  {
    fullName: 'Крылов Павел ',
    jobTitle: 'Владелец продукта SaluteRPA',
    description: 'SaluteRPA Сбер',
    photo: require('@/assets/speakers/Крылов.jpg')
  },
  {
    fullName: 'Серов Кирилл',
    jobTitle: 'CTO',
    description: 'PIX Robotics',
    photo: require('@/assets/speakers/Серов.jpg')
  },
  {
    fullName: 'Артемьев Константин',
    jobTitle: 'CEO Sherpa RPA',
    description: 'Sherpa RPA',
    photo: require('@/assets/speakers/Артемьев.jpg')
  },
  {
    fullName: 'Шишкин Данил',
    jobTitle: 'Заместитель руководителя отдела разработки ПО',
    description: 'Next',
    photo: require('@/assets/speakers/Шишкин.jpg')
  },
  {
    fullName: 'Кочетов Илья',
    jobTitle: 'Директор по технологическому развитию',
    description: 'Primo RPA',
    photo: require('@/assets/speakers/Кочетов.jpg')
  },
  {
    fullName: 'Нестеров Семен',
    jobTitle: 'Ведущий разработчик',
    description: 'Гринатом',
    photo: require('@/assets/speakers/Нестеров.jpg')
  },
  {
    fullName: 'Морьевский Сергей',
    jobTitle: 'Руководитель направления RPA',
    description: 'Альфа-банк',
    photo: require('@/assets/speakers/морьевский.jpg')
  }
]
